export default "__VITE_ASSET__WmENBGVj__"